import { BaseKey } from "@refinedev/core";
import { createContext } from 'react'

export const BreakdownProductContext = createContext<BaseKey[] | undefined>(
  undefined,
)
